import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.page.html',
  styleUrls: ['./about-us.page.scss'],
})
export class AboutUsPage implements OnInit {

  constructor( public platform: Platform,private router:Router,) {
  }
  ngOnInit() {
  }

  ionViewWillEnter(){

    this.platform.backButton.subscribeWithPriority(1, () => {
      this.router.navigate(['tabs/tab5']);
    });

}


  fb(){
    // const browser = this.iab.create('https://facebook.com/vytalhealth',  '_blank', 'location=no');  
  }

  lin(){
    // const browser = this.iab.create('https://www.linkedin.com/company/vytalhealth',  '_blank', 'location=no');
  }

  ig(){
    // const browser = this.iab.create('https://www.instagram.com/appvytal/',  '_blank', 'location=no');
  }

  twit(){
    // const browser = this.iab.create('https://twitter.com/vytalapp',  '_blank', 'location=no');
  }

  yt(){
    // const browser = this.iab.create('http://bit.ly/29HOZ0x',  '_blank', 'location=no');
  }

}
